import React from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

export const MobilePageTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();

  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18, ease: 'easeOut' }}
      className="max-lg:min-h-0 lg:contents"
    >
      {children}
    </motion.div>
  );
};

export default MobilePageTransition;
